import { auth } from '../firebase';
import { FirebaseError } from 'firebase/app';

/**
 * Speichert das Firebase-Token im localStorage, damit es für API-Anfragen verwendet werden kann
 */
export const storeFirebaseToken = async (): Promise<string | null> => {
  try {
    const currentUser = auth.currentUser;
    if (!currentUser) {
      console.error('Kein authentifizierter Benutzer gefunden');
      return null;
    }
    
    const token = await currentUser.getIdToken(true); // Force token refresh
    localStorage.setItem('authToken', token);
    return token;
  } catch (error) {
    console.error('Fehler beim Speichern des Firebase-Tokens:', error);
    return null;
  }
};

/**
 * Fügt einen Event-Listener hinzu, der das Token aktualisiert, wenn sich der Auth-Zustand ändert
 */
export const initAuthTokenRefresh = (): void => {
  auth.onAuthStateChanged(async (user: any) => {
    if (user) {
      await storeFirebaseToken();
    } else {
      localStorage.removeItem('authToken');
    }
  });
};

// Starte die Token-Aktualisierung beim Import des Moduls
initAuthTokenRefresh(); 